import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "Descricao",
      "label-for": "Descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "Intervalos",
      "label-for": "Intervalos",
      "label": "Intervalos"
    }
  }, [_c('VueSelect', {
    ref: "intervalos",
    attrs: {
      "filterable": false,
      "options": _vm.intervalos,
      "searchable": false
    },
    on: {
      "input": _vm.setIntervalo
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.intervaloSelected,
      callback: function callback($$v) {
        _vm.intervaloSelected = $$v;
      },
      expression: "intervaloSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Selecione o intervalo ")])], 2)], 1)], 1), _vm.form.tipo_repeticao === 9 ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "intervaloDias",
      "label-for": "intervaloDias",
      "label": "Intervalo em dias"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addInterval.apply(null, arguments);
      }
    },
    model: {
      value: _vm.intervaloDiasToAdd,
      callback: function callback($$v) {
        _vm.intervaloDiasToAdd = $$v;
      },
      expression: "intervaloDiasToAdd"
    }
  })], 1)], 1) : _vm._e(), _vm.form.tipo_repeticao === 9 ? _c('b-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('button', {
    on: {
      "click": _vm.addInterval
    }
  }, [_c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2"
  })], 1)]) : _vm._e()], 1), _vm.form.tipo_repeticao === 9 ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('TableApp', {
    ref: "nome",
    attrs: {
      "item": "intervalos",
      "subTitulo": "",
      "data": _vm.intervalo_dias_collection,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'dias' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "dias"
          },
          slot: "dias"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "value": props.rowData.dias,
            "type": "number"
          },
          on: {
            "change": function change(event) {
              return _vm.changeDiaValue(event, props.rowData);
            }
          }
        })], 1)])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click() {
              return _vm.removeInterval(props.rowData.originalIndex);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }], null, false, 4254169169)
  })], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vezes",
      "label-for": "vezes"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.form.tipo_repeticao === 9
    },
    model: {
      value: _vm.form.vezes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vezes", $$v);
      },
      expression: "form.vezes"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "MeioPagamento",
      "label-for": "MeioPagamento",
      "label": "Meio de Pagamento"
    }
  }, [_c('VueSelect', {
    ref: "meiosPagamentos",
    attrs: {
      "filterable": false,
      "options": _vm.meiosPagamentos,
      "searchable": false
    },
    on: {
      "input": _vm.setMeioPagamento
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.meioPagamentosSelected,
      callback: function callback($$v) {
        _vm.meioPagamentosSelected = $$v;
      },
      expression: "meioPagamentosSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Selecione o meio de pagamento ")])], 2)], 1)], 1)], 1), _vm.exibirTaxaAdministracao ? _c('div', {
    staticClass: "border rounded bg-light p-4 mb-6"
  }, [_vm._m(0), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "taxa",
      "label-for": "taxa",
      "label": "Taxa de administração (%)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "taxa",
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "placeholder": "Ex.: 2,50"
    },
    on: {
      "input": _vm.onTaxaInput
    },
    model: {
      value: _vm.form.taxa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "taxa", _vm._n($$v));
      },
      expression: "form.taxa"
    }
  }), _c('small', {
    staticClass: "form-text text-muted mt-2"
  }, [_vm._v(" Percentual descontado pela operadora sobre o valor total da venda. ")])], 1)], 1), _vm.exibirPlanoContasTaxa ? _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "planoContasTaxa",
      "label-for": "planoContasTaxa",
      "label": "Plano de contas da taxa (Despesa)"
    }
  }, [_c('VueSelect', {
    attrs: {
      "id": "planoContasTaxa",
      "filterable": true,
      "options": _vm.planosContasTaxa,
      "label": "descricao",
      "placeholder": "Selecione o plano de despesa"
    },
    on: {
      "input": _vm.setPlanoContasTaxa
    },
    model: {
      value: _vm.planoContasTaxaSelected,
      callback: function callback($$v) {
        _vm.planoContasTaxaSelected = $$v;
      },
      expression: "planoContasTaxaSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Nenhum plano de despesa encontrado ")])], 2), _c('small', {
    staticClass: "form-text text-muted mt-2"
  }, [_vm._v(" Será criada uma conta a pagar já baixada neste plano, sem gerar outra saída no caixa. ")])], 1)], 1) : _vm._e()], 1), _vm._m(1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "visualizar",
      "label": "Visualizar",
      "label-for": "visualizar"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.visualizar,
      expression: "form.visualizar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.visualizar) ? _vm._i(_vm.form.visualizar, null) > -1 : _vm.form.visualizar
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.visualizar,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "visualizar", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "visualizar", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "visualizar", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "visualizar_app",
      "label": "Visualizar App",
      "label-for": "visualizar_app"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.visualizar_app,
      expression: "form.visualizar_app"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.visualizar_app) ? _vm._i(_vm.form.visualizar_app, null) > -1 : _vm.form.visualizar_app
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.visualizar_app,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "visualizar_app", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "visualizar_app", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "visualizar_app", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "informar_cliente",
      "label": "Informar Cliente",
      "label-for": "informar_cliente"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.informar_cliente,
      expression: "form.informar_cliente"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.informar_cliente) ? _vm._i(_vm.form.informar_cliente, null) > -1 : _vm.form.informar_cliente
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.informar_cliente,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "informar_cliente", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "informar_cliente", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "informar_cliente", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "movimenta_caixa",
      "label": "Gerar movimento de caixa",
      "label-for": "movimenta_caixa"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.movimenta_caixa,
      expression: "form.movimenta_caixa"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.movimenta_caixa) ? _vm._i(_vm.form.movimenta_caixa, null) > -1 : _vm.form.movimenta_caixa
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.movimenta_caixa,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "movimenta_caixa", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "movimenta_caixa", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "movimenta_caixa", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "banco",
      "label-for": "banco"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Banco "), _c('i', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "fas fa-info-circle ml-1 text-muted",
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "title": "Informe o banco onde o valor será recebido."
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-form-select', {
    model: {
      value: _vm.form.banco,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "banco", $$v);
      },
      expression: "form.banco"
    }
  }, _vm._l(_vm.bancos, function (b) {
    return _c('b-form-select-option', {
      key: b.id_banco + 'bancos',
      attrs: {
        "value": b
      }
    }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
  }), 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "subit_novo_parcelamento",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'parcelamentos'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex align-items-center mb-4"
  }, [_c('i', {
    staticClass: "fas fa-percentage text-primary mr-3"
  }), _c('div', [_c('h6', {
    staticClass: "font-weight-bold mb-1"
  }, [_vm._v("Taxa do meio de pagamento")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Configure o desconto da operadora e sua classificação no DRE. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "alert alert-light border mb-0 py-3 px-4"
  }, [_c('i', {
    staticClass: "fas fa-lightbulb text-warning mr-2"
  }), _c('strong', [_vm._v("Exemplo:")]), _vm._v(" em uma venda de R$ 1.000,00 com taxa de 2,50%, cada parcela será gravada já com o desconto, totalizando R$ 975,00 a receber. Os R$ 25,00 serão registrados em uma conta a pagar já paga e aparecerão como despesa no DRE. ")]);
}];
export { render, staticRenderFns };